import React, { useMemo, useState } from 'react'
import { ChartType, MSLineProps, Series } from './MSLine.types'
import { IconBarChart, IconLineChart } from 'assets'
import styles from './MSLine.module.scss'
import cl from 'classnames'
import { buildMSLineOption } from './MSLine.utils'
import { ChartLegend } from './ChartLegend'
import { Button, Text1 } from 'components/shared'
import { EChart } from '../EChart'
import { toChartPixelHeight } from '../chartTheme'

const MSLineComponent = (props: MSLineProps) => {
  const {
    categories,
    dataset,
    height = 300,
    hideLegend,
    width,
    yAxisName,
    numberPrefix,
    headerLabel,
    eventsLegend,
    best
  } = props

  const [chartType, setChartType] = useState(ChartType.LINE)

  const resolvedDataset = useMemo(() => {
    const series = (dataset || []).slice() as Series[]
    if (best && !(series[0] && series[0].isBest)) {
      series.unshift(best)
    }
    return series
  }, [dataset, best])

  const legend = resolvedDataset.filter((series) => !series.isBest)

  const option = useMemo(
    () => buildMSLineOption({
      yAxisName,
      numberPrefix,
      dataset: resolvedDataset,
      categories
    }, chartType),
    [yAxisName, numberPrefix, resolvedDataset, categories, chartType]
  )

  const fillParent = height === '100%'
  const chartHeight = fillParent ? '100%' : toChartPixelHeight(height)

  return (
    <div
      className={styles.wrapper}
      style={{ width: width || '100%' }}
    >
      <div className={styles.headContainer}>
        {hideLegend
          ? (
            <Text1 bold>
              {headerLabel}
            </Text1>
          )
          : (
            <ChartLegend
              elements={legend.map((value) => ({
                label: value.seriesname,
                color: value.anchorBgColor,
                image: value.image
              }))}
            />
          )}

        <Text1 className={styles.eventsLegend}>
          {eventsLegend}
        </Text1>

        <Button
          preset='icon'
          className={cl(styles.chartTypeButton, {
            [styles.chartTypeButtonSelected]: chartType === ChartType.LINE
          })}
          onClick={() => setChartType(ChartType.LINE)}
          title='Switch to Line chart type'
        >
          <IconLineChart />
        </Button>
        <Button
          preset='icon'
          className={cl(styles.chartTypeButton, {
            [styles.chartTypeButtonSelected]: chartType === ChartType.BAR
          })}
          onClick={() => setChartType(ChartType.BAR)}
          title='Switch to Bar chart type'
        >
          <IconBarChart />
        </Button>
      </div>
      <div
        className={styles.chartBody}
        style={fillParent ? undefined : { height: chartHeight, minHeight: 0 }}
      >
        <EChart
          option={option}
          width='100%'
          height='100%'
        />
      </div>
    </div>
  )
}

const MSLine = MSLineComponent
export { MSLine }
